<ion-grid>
	<ion-row>
		<ion-col>
			<ion-grid class="max-w-1336" *ngIf="getCohortList$ | async as cohortList">
				<ion-row>
					<ng-container *ngIf="cohortList.isSkeleton">
						<ion-grid class="side-menu-wrapper text-center">
							<ion-spinner class="ion-spinner"></ion-spinner>
						</ion-grid>
					</ng-container>
				</ion-row>
				<ion-row>
					<ion-col col="12">
						<dx-data-grid
							id="gridContainer"
							[dataSource]="cohortList.data"
							[allowColumnResizing]="true"
							[columnAutoWidth]="true"
							[showBorders]="true"
							*ngIf="cohortList.data"
						>
							<dxo-search-panel
								[visible]="true"
								[width]="240"
								placeholder="Search..."
							></dxo-search-panel>
							<dxo-header-filter>
								[visible]="showHeaderFilter"
							</dxo-header-filter>
							<dxo-column-chooser
								[enabled]="true"
								mode="select"
							></dxo-column-chooser>
							<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

							<dxi-column
								caption="ACTIONS"
								[allowFiltering]="false"
								[allowSorting]="false"
								cellTemplate="cellTemplate"
							>
							</dxi-column>
							<dxi-column caption="ID" dataField="id"> </dxi-column>
							<dxi-column dataField="name" caption="NAME"></dxi-column>
							<dxi-column dataField="alias" caption="ALIAS"></dxi-column>
							<dxi-column
								dataField="calendarId"
								caption="CALENDAR ID"
							></dxi-column>

							<div *dxTemplate="let d of 'cellTemplate'">
								<!-- {{d | json}} -->
								<!-- <a class="cursor" (click)="editCohort(d,$event)">Edit</a> / -->
								<a class="cursor" (click)="viewInfo(d.data.id)">View</a>
							</div>

							<dxo-toolbar>
								<!-- <dxi-item location="before">
									<div *dxTemplate class="informer">
										<ion-button (click)="addCohort()"
											><ion-icon name="add-outline"></ion-icon
										></ion-button>
									</div>
								</dxi-item> -->

								<dxi-item location="before">
									<div *dxTemplate class="informer">
										<p
											class="Heading_M"
											*ngIf="(courseName$ | async) as courseName"
										>
											{{courseName.name}}
										</p>
									</div>
								</dxi-item>

								<dxi-item name="columnChooserButton"></dxi-item>

								<dxi-item name="searchPanel"></dxi-item>
							</dxo-toolbar>
						</dx-data-grid>
					</ion-col>
				</ion-row>
			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>
